import { instance } from "api/apiBase";

export type SupportContactSource =
  | "user_menu"
  | "boom_help_message_support"
  | "boom_help_fallback"
  | "manual_application_checkout"
  | "canadian_criminal_report"
  | "report_exception"
  | "rent_reporting_upload";

export const recordSupportContact = (source: SupportContactSource) =>
  instance
    .post("/portal/v1/support_contacts", {
      source,
      page: window.location.pathname
    })
    .catch(() => undefined);
